<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content>
  <data-table (detail)="onDetail($event)"
                  [columns]="columns"
                  [dataProviderParams]="params"
                  [dataProvider]="packageService"
                  [title]="'Failed packages'"
                  noDataMessage="Hooray no packages failing"></data-table>
</page-content>

